module.exports = __webpack_public_path__ + "img/items.d882334e.webp";